// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-modals-___styles__original___geFZJ{margin-bottom:20px}.src-modals-___styles__original___geFZJ a{color:#26b1e2}.src-modals-___styles__walletButtonContainer___CdOSX{align-items:center;display:flex;flex-direction:column;margin-top:40px}.src-modals-___styles__walletButton___GHwuq{align-items:center;border:1px solid #70c063;border-radius:20px;cursor:pointer;display:flex;flex-direction:row;height:38px;margin-bottom:28px;max-width:32px;min-width:253px;padding:0 16px}.src-modals-___styles__walletButton___GHwuq .src-modals-___styles__buttonIconContainer___1MwBh{flex:1;margin-right:28px}.src-modals-___styles__walletButton___GHwuq .src-modals-___styles__buttonTextContainer___9T4oU{flex:9}.src-modals-___styles__walletButton___GHwuq .src-modals-___styles__buttonCloseIconContainer___TlDzZ{flex:1}.src-modals-___styles__walletButton___GHwuq .src-modals-___styles__buttonIcon___cXLM9{width:30px}.src-modals-___styles__connectedWalletBtn___T5Wff{border:3px solid #70c063}.src-modals-___styles__disabled___hXLYO{background:\"rgb(112,112,112)\";cursor:not-allowed}", "",{"version":3,"sources":["webpack://src/modals/styles.scss"],"names":[],"mappings":"AAAsuC,wCAAU,kBAAkB,CAAC,0CAAY,aAAa,CAAC,qDAAuB,kBAAkB,CAAC,YAAY,CAAC,qBAAqB,CAAC,eAAe,CAAC,4CAAc,kBAAkB,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,cAAc,CAAC,YAAY,CAAC,kBAAkB,CAAC,WAAW,CAAC,kBAAkB,CAAC,cAAc,CAAC,eAAe,CAAC,cAAc,CAAC,+FAAmC,MAAM,CAAC,iBAAiB,CAAC,+FAAmC,MAAM,CAAC,oGAAwC,MAAM,CAAC,sFAA0B,UAAU,CAAC,kDAAoB,wBAAwB,CAAC,wCAAU,6BAA6B,CAAC,kBAAkB","sourcesContent":[":export{bannerRed:rgba(218,20,20,.1);bannerSuccess:rgba(90,202,117,.3);blue:#1c5898;boxShadowGrey:rgba(11,9,44,.2);btnActive:#0095e2;btnDefault:#2fb4f9;btnDisabled:#acb8bc;btnGhostActive:rgba(0,149,226,.1);btnGhostDefault:rgba(0,0,0,0);btnGhostHover:rgba(100,193,241,.1);btnHover:#64c1f1;btnSecondaryActive:rgba(0,149,226,.1);btnSecondaryDefault:rgba(47,180,249,.1);btnSecondaryDisabled:#f4f6f6;btnSecondaryHover:rgba(100,193,241,.1);charcoal:#333;coral:#ed7f69;darkGrey:#6b6c7e;error:#da1414;errorColor:#da1414;faintBlue:rgba(28,88,152,.05);green:#59bf28;grey:#acb8bc;lightBlue:#2fb4f9;lightGrayRuler:#f4f6f6;lightGrey:#f1f1f1;lightPineTree:#e5f3f0;modalOverlay:rgba(32,33,38,.45);modalWrapperBackground:rgba(0,0,0,.2);olive:#20cb9a;orange:#fe7a24;peach:#fdc;pineTree:#4e8c8a;primary:#26b1e2;primaryHover:#64c1f1;red:#fa1931;sea:rgba(47,181,249,.1);seaPrimary:#2fb4f9;seaPrimaryWithAlpha:rgba(47,180,249,.1);secondary:#ffa959;silver:#acb8bc;success:#70c063;warning:#ff8f39;white:#fff}:export{hugeFont:36px;inputHeight:38px;l:24px;lFont:18px;m:20px;s:16px;sFont:14px;slimButtonHeight:24px;smallestFont:10px;smallestSpacer:5px;spacer:15px;standardFont:14px;xl:28px;xs:12px;xsFont:12px;xxl:32px;xxs:8px;xxsFont:10px;xxxl:40px;xxxs:4px;xxxxl:64px;xxxxs:2px}.original{margin-bottom:20px}.original a{color:#26b1e2}.walletButtonContainer{align-items:center;display:flex;flex-direction:column;margin-top:40px}.walletButton{align-items:center;border:1px solid #70c063;border-radius:20px;cursor:pointer;display:flex;flex-direction:row;height:38px;margin-bottom:28px;max-width:32px;min-width:253px;padding:0 16px}.walletButton .buttonIconContainer{flex:1;margin-right:28px}.walletButton .buttonTextContainer{flex:9}.walletButton .buttonCloseIconContainer{flex:1}.walletButton .buttonIcon{width:30px}.connectedWalletBtn{border:3px solid #70c063}.disabled{background:\"rgb(112,112,112)\";cursor:not-allowed}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerRed": "rgba(218,20,20,.1)",
	"bannerSuccess": "rgba(90,202,117,.3)",
	"blue": "#1c5898",
	"boxShadowGrey": "rgba(11,9,44,.2)",
	"btnActive": "#0095e2",
	"btnDefault": "#2fb4f9",
	"btnDisabled": "#acb8bc",
	"btnGhostActive": "rgba(0,149,226,.1)",
	"btnGhostDefault": "rgba(0,0,0,0)",
	"btnGhostHover": "rgba(100,193,241,.1)",
	"btnHover": "#64c1f1",
	"btnSecondaryActive": "rgba(0,149,226,.1)",
	"btnSecondaryDefault": "rgba(47,180,249,.1)",
	"btnSecondaryDisabled": "#f4f6f6",
	"btnSecondaryHover": "rgba(100,193,241,.1)",
	"charcoal": "#333",
	"coral": "#ed7f69",
	"darkGrey": "#6b6c7e",
	"error": "#da1414",
	"errorColor": "#da1414",
	"faintBlue": "rgba(28,88,152,.05)",
	"green": "#59bf28",
	"grey": "#acb8bc",
	"lightBlue": "#2fb4f9",
	"lightGrayRuler": "#f4f6f6",
	"lightGrey": "#f1f1f1",
	"lightPineTree": "#e5f3f0",
	"modalOverlay": "rgba(32,33,38,.45)",
	"modalWrapperBackground": "rgba(0,0,0,.2)",
	"olive": "#20cb9a",
	"orange": "#fe7a24",
	"peach": "#fdc",
	"pineTree": "#4e8c8a",
	"primary": "#26b1e2",
	"primaryHover": "#64c1f1",
	"red": "#fa1931",
	"sea": "rgba(47,181,249,.1)",
	"seaPrimary": "#2fb4f9",
	"seaPrimaryWithAlpha": "rgba(47,180,249,.1)",
	"secondary": "#ffa959",
	"silver": "#acb8bc",
	"success": "#70c063",
	"warning": "#ff8f39",
	"white": "#fff",
	"hugeFont": "36px",
	"inputHeight": "38px",
	"l": "24px",
	"lFont": "18px",
	"m": "20px",
	"s": "16px",
	"sFont": "14px",
	"slimButtonHeight": "24px",
	"smallestFont": "10px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"standardFont": "14px",
	"xl": "28px",
	"xs": "12px",
	"xsFont": "12px",
	"xxl": "32px",
	"xxs": "8px",
	"xxsFont": "10px",
	"xxxl": "40px",
	"xxxs": "4px",
	"xxxxl": "64px",
	"xxxxs": "2px",
	"original": "src-modals-___styles__original___geFZJ",
	"walletButtonContainer": "src-modals-___styles__walletButtonContainer___CdOSX",
	"walletButton": "src-modals-___styles__walletButton___GHwuq",
	"buttonIconContainer": "src-modals-___styles__buttonIconContainer___1MwBh",
	"buttonTextContainer": "src-modals-___styles__buttonTextContainer___9T4oU",
	"buttonCloseIconContainer": "src-modals-___styles__buttonCloseIconContainer___TlDzZ",
	"buttonIcon": "src-modals-___styles__buttonIcon___cXLM9",
	"connectedWalletBtn": "src-modals-___styles__connectedWalletBtn___T5Wff",
	"disabled": "src-modals-___styles__disabled___hXLYO"
};
export default ___CSS_LOADER_EXPORT___;
